import { render, staticRenderFns } from "./upload-media.vue?vue&type=template&id=5368c104&scoped=true"
import script from "./upload-media.vue?vue&type=script&lang=js"
export * from "./upload-media.vue?vue&type=script&lang=js"
import style0 from "./upload-media.vue?vue&type=style&index=0&id=5368c104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368c104",
  null
  
)

export default component.exports